
import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, OnInit, output, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioGroup } from '@angular/material/radio';
import { RadioComponent, RadioTabComponent } from '@shared/ui-forms';
import { ResidentialAddress } from '../../models/residential-address.model';
import { AddressFormComponent } from '../address-form/address-form.component';

const CSL_IMPORTS = [AddressFormComponent, RadioComponent, RadioTabComponent, MatRadioGroup];

@Component({
  selector: 'csl-billing-address',
  standalone: true,
  imports: [FormsModule, ...CSL_IMPORTS],
  templateUrl: './billing-address.component.html',
  styleUrl: './billing-address.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingAddressComponent implements OnInit {
  initialAddress: ResidentialAddress | null = null;
  personalAddress: ResidentialAddress | null = null;
  useServiceAddress = false;
  poBoxModel = false;
  isDisabled = input<boolean>(false);

  @Input({ required: true }) address!: ResidentialAddress;

  @Input() set billingAddress(value: ResidentialAddress) {
    this.initialAddress = { ...value };
    this.personalAddress = { ...value };
    this.poBoxModel = !!value.poBoxNumber;
  }

  @Output() addressChange = new EventEmitter<ResidentialAddress | null>();
  cityChanged = output<void>();
  stateChanged = output<void>();
  zipChanged = output<void>();
  streetError = output<string>();
  cityError = output<string>();
  zipError = output<string>();
  stateError = output<string>();

  ngOnInit(): void {
    this.useServiceAddress = this.getValueForUseServiceAddress(this.initialAddress);
  }

  onUseServiceAddressChanged(useServiceAddress: boolean): void {
    this.useServiceAddress = useServiceAddress;
    this.initialAddress = useServiceAddress ? { ...this.address } : null;
    this.personalAddress = useServiceAddress ? { ...this.address } : null;
    this.addressChange.next(this.personalAddress);
  }

  addressChanged(address: ResidentialAddress | null): void {
    this.personalAddress = address;
    this.useServiceAddress = this.getValueForUseServiceAddress(address);
    this.addressChange.next(this.personalAddress);
  }

  private getValueForUseServiceAddress(addressForCompare: ResidentialAddress | null): boolean {
    if (!addressForCompare) {
      return false;
    }

    const { street, street2, city, state, zip } = this.address;

    const {
      street: compareStreet,
      street2: compareStreet2,
      city: compareCity,
      state: compareState,
      zip: compareZip,
      poBoxNumber,
    } = addressForCompare;

    if (poBoxNumber) {
      return false;
    }

    return (
      street === compareStreet &&
      street2 === compareStreet2 &&
      city === compareCity &&
      state === compareState &&
      zip === compareZip
    );
  }
}
